<template>
    <div class="wrapper">
        <div class="breathing-page">
            <div class="container">
                <div class="modal fade" ref="my_modal" id="staticBackdrop" role="dialog" aria-hidden="true">
      <!-- <div class="modal" v-bind:class="{'is-active':showModal}"> -->

    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content modal_div">
        <!-- <div class="modal-header" style="padding:35px 50px;">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4><span class="glyphicon glyphicon-lock"></span> Login</h4>
        </div> -->
            <!-- <div class="form-group">
              <label for="usrname"><span class="glyphicon glyphicon-user"></span> Username</label>
              <input type="text" class="form-control" id="usrname" placeholder="Enter email">
            </div> -->
            <div class="life-area-modal text-center mx-auto content-div" style="padding-right: 18%;padding-left: 10%;padding-bottom: 9%;">
              <form role="form" >
              <div class="animation-div">
                <lottie-animation speed="1" :path="'bubble_loading.json'"/>
              </div>
              <h1>Instructions</h1>
              <ul style="text-align: justify;">
                <li v-for="data in question" :key="data">{{data}}</li>
              </ul>
            <button type="button" @click="close_modal" class="modal-continue-btn">Let's Start</button>
            </form>
            </div>
        <!-- <div class="modal-footer"> -->
          <!-- <button type="submit" class="btn btn-danger btn-default pull-left" data-dismiss="modal"><span class="glyphicon glyphicon-remove"></span> Cancel</button> -->
          <!-- <p>Not a member? <a href="#">Sign Up</a></p>
          <p>Forgot <a href="#">Password?</a></p> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
                <div class="breath-content py-3">
                    <div class="animation-wrap">
                        <!-- <img src="@/assets/image/Ellipse.png"/> -->
                        <lottie-animation :speed=0.1
           :path="'breathing_animation.json'"/>
                        <!-- <h3>3</h3> -->
                    </div>
                    <h5>Deep <span>Breathing....</span></h5>
                    <span style="color: whitesmoke;">You may repeat this process with as many negative belief and feelings as you like before proceeding to the next phase</span>
                    <div class="row btn-container">
                       <div class="col-md-6"><button @click="next" style="margin-top:0px;margin-left: 41%;">Next</button></div>
                        <!-- <div @click="next" class="col-md-6"><span style="margin-top: 60px;color: white;cursor: pointer;" >Next  <i class="fa fa-angle-right"></i></span></div> -->
                    </div>
                    <!-- <button>Repeat</button>
                    <router-link to="congratulations"><span style="margin-top: -12%;margin-left: 82%;color: white;">Next  <i class="fa fa-angle-right"></i></span></router-link> -->
                </div>

            </div>
        </div>
    </div>
</template>
<style scoped>
@import './../assets/css/style_new.css';
.btn-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 25px;
}
.animation-div{
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    z-index: -99
}
.content-div{
    position: relative;
    z-index: 99;
}
.modal_div{
  border-radius: 28px;
  width: 30%;
  height: 10%;
  margin-left: 15%;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
li {
  padding-left: 1em;
  text-indent: -.7em;
}
li::before {
  content: "";
  background-color: #DBAF16;
  height: 7px;
  width: 7px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}
</style>
<script>
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue' // import lottie-vuejs
import axios from 'axios'
export default {
  components: {
    LottieAnimation
  },
  data () {
    return {
      user_id: 0,
      myJson: [],
      question: '',
      questionId: 0,
      lifearea_id: 0,
      lifearea: '',
      base_url: '',
      token: ''
    }
  },
  methods: {
    async getData () {
      this.base_url = process.env.VUE_APP_WEBAPP_URL
      console.log(this.base_url)
      this.token = localStorage.getItem('api_token')
      if (this.lifearea_id === 1) {
        const json = import('../../public/questions/selfAIT.json')
        this.myJson = await json
        this.question = this.myJson.data.phase3.questions[10]?.question.split('\n')
        this.questionId = this.myJson.data.phase3.questions[10].id
      } else if (this.lifearea_id === 2) {
        const json = import('../../public/questions/friendsAIT.json')
        this.myJson = await json
        this.question = this.myJson.data.phase3.questions[10]?.question.split('\n')
        this.questionId = this.myJson.data.phase3.questions[10].id
      }
    },
    async next () {
      console.log('next')
      axios.post(process.env.VUE_APP_WEBAPP_URL + '/answer/aittest', {
        test_id: this.self_id,
        question_id: this.questionId,
        answer: 'breathing_done'
      }, {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
        .then((response) => {
          console.log(response)
          this.$router.push({ path: '/ait_three_congratulations' })
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    async close_modal () {
      document.getElementById('staticBackdrop').classList.remove('show')
      document.getElementById('staticBackdrop').style.display = 'none'
    },
    async getUserDetails () {
      this.base_url = process.env.VUE_APP_WEBAPP_URL
      this.user_id = localStorage.getItem('user_id')
      this.token = localStorage.getItem('api_token')
      const response = await axios.get(this.base_url + '/session/getCurrentTest/', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      console.log('response getcurrenttest ===', response.data.data.lifearea_id)
      if (response.data.data.lifearea_id === 1) {
        const json = import('../../public/questions/selfAIT.json')
        this.myJson = await json
        this.question = this.myJson.data.phase3.questions[10]?.question.split('\n')
        this.questionId = this.myJson.data.phase3.questions[10].id
      } else if (response.data.data.lifearea_id === 2) {
        const json = import('../../public/questions/friendsAIT.json')
        this.myJson = await json
        this.question = this.myJson.data.phase3.questions[10]?.question.split('\n')
        this.questionId = this.myJson.data.phase3.questions[10].id
      } else if (response.data.data.lifearea_id === 3) {
        const json = import('../../public/questions/careerAIT.json')
        this.myJson = await json
        this.question = this.myJson.data.phase3.questions[10]?.question.split('\n')
        this.questionId = this.myJson.data.phase3.questions[10].id
      } else if (response.data.data.lifearea_id === 4) {
        const json = import('../../public/questions/finance_ait.json')
        this.myJson = await json
        this.question = this.myJson.data.phase3.questions[10]?.question.split('\n')
        this.questionId = this.myJson.data.phase3.questions[10].id
      } else if (response.data.data.lifearea_id === 5) {
        const json = import('../../public/questions/relationshipAIT.json')
        this.myJson = await json
        this.question = this.myJson.data.phase3.questions[10]?.question.split('\n')
        this.questionId = this.myJson.data.phase3.questions[10].id
      } else if (response.data.data.lifearea_id === 6) {
        const json = import('../../public/questions/familyAIT.json')
        this.myJson = await json
        this.question = this.myJson.data.phase3.questions[10]?.question.split('\n')
        this.questionId = this.myJson.data.phase3.questions[10].id
      }
      this.self_id = response.data.data.test_id
    }
  },
  mounted: function () {
    document.getElementById('staticBackdrop').classList.add('show')
    document.getElementById('staticBackdrop').style.display = 'block'
    this.getUserDetails()
  }
}
</script>
